import { infotrack } from '../../api/infotrack';
import { BrowserFourdApi } from '.';

export class Infotrack implements infotrack.Api {
  constructor(private fourd: BrowserFourdApi) {}

  orderSearch(request: infotrack.CreateSearchRequest): void {
    this.fourd.call4Dv2('infotrack.orderSearch', request);
  }
}
